import './styles/index.scss'
import reportWebVitals from './reportWebVitals'
import initWidgets from './widgets/initWidgets'
import './i18n'

initWidgets()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
